import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/websites/',
  },
  {
    path: '/websites/',
    name: 'home',
    component: () => import('@/modules/collaboration/views/websites/WebsitesList.vue'),
    meta: {
      header: 'Websites',
      sidebar: 'main',
      layout: 'default',
    },
  },
  {
    path: '/:websiteId/',
    component: () => import('@/modules/collaboration/views/websites/WebsitesIndex.vue'),
    children: [
      {
        //if the path is /:websiteId/ then redirect to /websites/
        path: '',
        redirect: '/websites/',
      },
      {
        path: 'experiments/',
        component: () => import('@/modules/optimization/views/experiments/ExperimentsIndex.vue'),
        children: [
          {
            path: '',
            name: 'ExperimentsList',
            component: () => import('@/modules/optimization/views/experiments/ExperimentsList.vue'),
            meta: { header: 'Experiments' },
          },
          {
            path: 'edit/',
            redirect: '/404',
            component: () => import('@/modules/optimization/views/experiments/Wizard.vue'),
            children: [
              {
                path: ':id/',
                name: 'ExperimentWizardGeneral',
                component: () =>
                  import('@/modules/optimization/views/experiments/WizardSteps/General.vue'),
                meta: { header: 'New Experiment' },
              },
              {
                path: ':id/variations',
                name: 'ExperimentWizardVariations',
                component: () =>
                  import('@/modules/optimization/views/experiments/WizardSteps/Variations.vue'),
                meta: { header: 'New Experiment' },
              },
              {
                path: ':id/targeting',
                name: 'ExperimentWizardTargeting',
                component: () =>
                  import('@/modules/optimization/views/experiments/WizardSteps/Targeting.vue'),
                meta: { header: 'New Experiment' },
              },
              {
                path: ':id/audience',
                name: 'ExperimentWizardAudience',
                component: () =>
                  import('@/modules/optimization/views/experiments/WizardSteps/AudienceIndex.vue'),
                meta: { header: 'New Experiment', hideWizardNav: true },
              },
              {
                path: ':id/goals',
                name: 'ExperimentWizardGoals',
                component: () =>
                  import('@/modules/optimization/views/experiments/WizardSteps/Goals.vue'),
                meta: { header: 'New Experiment' },
              },
              {
                path: ':id/start',
                name: 'ExperimentWizardStart',
                component: () =>
                  import('@/modules/optimization/views/experiments/WizardSteps/Start.vue'),
                meta: { header: 'New Experiment' },
              },
            ],
          },
          {
            path: 'edit/:id/editor',
            name: 'ExperimentWizardEditor',
            component: () =>
              import('@/modules/optimization/views/experiments/WizardSteps/Editor.vue'),
            meta: { layoutEmpty: true },
          },
        ],
      },
      {
        path: 'personalizations/',
        component: () =>
          import('@/modules/optimization/views/personalizations/PersonalizationsIndex.vue'),
        children: [
          {
            path: '',
            name: 'PersonalizationsList',
            component: () =>
              import('@/modules/optimization/views/personalizations/PersonalizationsList.vue'),
            meta: { header: 'Personalizations' },
          },
          {
            path: 'edit/',
            redirect: '/404',
            component: () => import('@/modules/optimization/views/personalizations/Wizard.vue'),
            children: [],
          },
          {
            path: 'edit/:id/editor',
            name: 'PersonalizationWizardEditor',
            component: () =>
              import('@/modules/optimization/views/personalizations/WizardSteps/Editor.vue'),
            meta: { layoutEmpty: true },
          },
        ],
      },
      {
        path: 'realtime/',
        name: 'Realtime',
        component: () => import('@/modules/optimization/views/realtime/RealtimeIndex.vue'),
        meta: { header: 'Realtime Analytics' },
      },
      {
        path: 'realtime/session/:sessionId',
        name: 'SessionDetail',
        component: () => import('@/modules/optimization/views/realtime/SessionDetail.vue'),
        meta: { header: 'Session Details' },
      },
      {
        path: 'settings/',
        name: 'Settings',
        component: () => import('@/modules/collaboration/views/settings/SettingsIndex.vue'),
        meta: { header: 'Settings' },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
